type LazyBlockRenderResponse = Array<{status: string, content: string}>;

document.addEventListener('DOMContentLoaded', () => {
	const perPostId: [Element[], string[]][] = [];
	document.querySelectorAll('.summitorthoLazyBlock').forEach(element => {
		const rawBlockPost = element.getAttribute('data-block-post');
		if (!rawBlockPost) {
			return;
		}
		const blockPost = parseInt(rawBlockPost);
		const blockId = element.getAttribute('data-block-id');
		if (blockPost && blockId) {
			if (!perPostId[blockPost]) {
				perPostId[blockPost] = [[], []];
			}
			perPostId[blockPost][0].push(element);
			perPostId[blockPost][1].push(`${blockPost}:${blockId}`);
		}
	});

	const elements = perPostId.flatMap(e => e[0]);
	const blocks = perPostId.flatMap(e => e[1]);
	if (!blocks.length) {
		return;
	}

	const url = new URL(`/wp-json/plaudit/summitortho/v1/lazy-block/render/${blocks.join(',')}`, document.baseURI);
	url.search = location.search;
	fetch(url, {method: 'POST'})
		.then<LazyBlockRenderResponse>(resp => resp.json())
		.then(loadedBlock => {
			for (let i = 0; i < elements.length; i++) {
				const {status, content} = loadedBlock[i];
				if (status === 'success') {
					elements[i].replaceWith(...new DOMParser().parseFromString(content, 'text/html').body.children);
				} else {
					elements[i].classList.remove('loading');
					elements[i].classList.toggle('failed', true);
					elements[i].classList.toggle(`failed--${status}`, true);
				}
			}
		});
});
